import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationBN from './locales/bn/translation.json';

const resources = {
    en: { translation: translationEN },
    bn: { translation: translationBN }
};

i18n
    .use(LanguageDetector) // Detects the user's language
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
        resources,
        lng: 'bn',            // Set default language
        fallbackLng: 'bn',    // Fallback language if detection fails
        interpolation: {
            escapeValue: false // React already handles escaping
        },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'], // detection priority
            caches: ['localStorage']
        }
    });

export default i18n;
